import { Panel } from "@/components/AppShell";
import { useFetch } from "@/lib/api";
import { RESULTS } from "@/lib/quiz";

const COLS = [["complete", "Completed"], ["shares", "Shared"], ["copy", "Copy"], ["facebook", "Facebook"], ["linkedin", "LinkedIn"], ["x", "X"], ["arrival", "Friend visits"]];

export function QuizStatsCard() {
  const { data } = useFetch("/admin/quiz-stats");
  return (
    <Panel title="Quiz results & shares" className="mb-6" testid="quiz-stats-card">
      {!data ? <p className="text-sm text-muted-foreground">Loading...</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[640px]">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-muted-foreground"><th className="py-2 pr-3">Result</th>{COLS.map(([k, l]) => <th key={k} className="py-2 px-2 text-right">{l}</th>)}</tr></thead>
            <tbody>
              {data.results.map((r) => (
                <tr key={r.result} className="border-t border-border/60" data-testid={`quiz-stats-row-${r.result}`}>
                  <td className="py-2.5 pr-3 font-medium">{RESULTS[r.result].short}</td>
                  {COLS.map(([k]) => <td key={k} className="py-2.5 px-2 text-right font-mono-num" data-testid={`quiz-stats-${r.result}-${k}`}>{r[k]}</td>)}
                </tr>
              ))}
              <tr className="border-t-2 border-border font-semibold" data-testid="quiz-stats-row-total">
                <td className="py-2.5 pr-3">Total</td>
                {COLS.map(([k]) => <td key={k} className="py-2.5 px-2 text-right font-mono-num" data-testid={`quiz-stats-total-${k}`}>{data.totals[k]}</td>)}
              </tr>
            </tbody>
          </table>
          <p className="text-xs text-muted-foreground mt-3">Anonymous counts. "Shared" = copy + social button clicks; "Friend visits" = people who opened a shared link.</p>
        </div>
      )}
    </Panel>
  );
}
